import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "absolute h-40 right-10 inset-y-12" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-lg font-poppins font-normal text-gray-900" }
const _hoisted_5 = { class: "mt-0 h-24 flex flex-col items-baseline text-gray-900 leading-9 font-poppins-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-5xl font-extrabold tracking-tight font-poppins-bold"
}
const _hoisted_7 = { class: "flex flex-wrap gap-2 mb-2 min-h-[34px]" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  role: "list",
  class: "mt-0 lg:mt-4 mb-2 space-y-6"
}
const _hoisted_10 = { class: "flex h-16" }
const _hoisted_11 = { class: "text-black font-poppins text-sm" }
const _hoisted_12 = { class: "max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md" }

import { ref, computed } from 'vue';
import HardwareImage from './HardwareImage.vue';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
  img?: string,
  imghover?: string
}

type ProductVariant = {
  units: number,
  product: Product
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HardwareSelectorProduct',
  props: {
    isSelectedProduct: { type: Boolean },
    variants: {},
    selected: {}
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Unit count the user has locally toggled to preview, before it becomes the
// globally selected hardware product. Defaults to the lowest unit-count
// variant (e.g. the base, non-bundle product).
const previewUnits = ref(props.variants[0].units);

const activeVariant = computed<ProductVariant>(() => {
  const selectedVariant = props.variants.find(variant => variant.product.id === props.selected);
  if (selectedVariant) {
    return selectedVariant;
  }
  return props.variants.find(variant => variant.units === previewUnits.value) ?? props.variants[0];
});

const product = computed<Product>(() => activeVariant.value.product);

const handleUnitClick = (units: number, event: Event) => {
  event.stopPropagation();
  previewUnits.value = units;
  const variant = props.variants.find(variant => variant.units === units);
  if (variant) {
    emit('handle-select-product', variant.product);
  }
};

const handleSelectProduct = () => {
  emit('handle-select-product', activeVariant.value.product);
};

const checkDiscount = (product: Product): number => {
  if (product.name === 'Nokia WiFi Beacon 1.1 Bundle 2') {
    return 230;
  }
  if (product.name === 'Nokia WiFi Beacon 2') {
    return 129;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 1') {
    return 249;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 2') {
    return 379;
  }
  if (product.name === 'Nokia Beacon 3.1') {
    return 149;
  }
  if (product.name === 'Nokia Beacon 3.1 Bundle 1') {
    return 249;
  }
  return 0;
};

// checkDiscount holds hardcoded pre-price-increase amounts; once a product's
// live price catches up to that amount there's no discount left to show.
const hasDiscount = (product: Product): boolean => {
  const previousPrice = checkDiscount(product);
  return previousPrice > 0 && previousPrice !== product.price;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(product.value))),
    class: _normalizeClass(["group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 cursor-pointer", { 'bg-opacity-100': !_ctx.isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1': _ctx.isSelectedProduct}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none", [_ctx.isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300 h-20",
          src: product.value.img
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300 h-24",
          src: product.value.imghover
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(product.value.name.toUpperCase()), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(['tracking-tight', product.value.displayDiscount || hasDiscount(product.value) ? 'text-decoration-line: line-through text-xl text-gray-500 font-bold' : 'text-5xl text-gray-900 font-extrabold'])
        }, "$" + _toDisplayString(hasDiscount(product.value) ? checkDiscount(product.value) : product.value.price), 3),
        (product.value.displayDiscount || hasDiscount(product.value))
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "$" + _toDisplayString(hasDiscount(product.value) ? product.value.price : product.value.discountedPrice), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.variants.length > 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.variants, (variant) => {
              return (_openBlock(), _createElementBlock("button", {
                key: variant.units,
                type: "button",
                onClick: ($event: any) => (handleUnitClick(variant.units, $event)),
                class: _normalizeClass(["px-4 py-1 text-sm rounded-full border font-poppins transition ease-in-out duration-100", [
              activeVariant.value.units === variant.units
                ? 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark text-white border-transparent'
                : 'bg-white text-gray-900 border-gray-400 hover:border-gray-600'
            ]])
              }, _toDisplayString(variant.units) + " Unit" + _toDisplayString(variant.units > 1 ? 's' : ''), 11, _hoisted_8))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _createVNode(HardwareImage, { product: product.value }, null, 8, ["product"]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(product.value.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: _normalizeClass(["cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none", [_ctx.isSelectedProduct? 'bg-transparent' : 'bg-white']])
        }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
      ])
    ], 2)
  ], 2))
}
}

})